import { FC } from 'react';
import TextInput from '../text-input';
import { FormProps } from '../helpers';
import { validateRegexPattern } from '@/lib/regex-helpers';

interface RegexPatternInputProps extends FormProps {
  value: string;
  onChange: (value: string) => void;
  onEnter?: (value: string) => void;
  autoComplete?: string;
  rows?: number;
  maxLength?: number;
  updateOnly?: boolean;
  length?: number;
  copyClip?: boolean;
  setFieldError: (field: string, message: string | undefined) => void;
}

const RegexPatternInput: FC<RegexPatternInputProps> = ({
  name,
  label,
  value,
  onChange,
  onEnter,
  setFieldError,
  disabled = false,
  fullWidth = true,
  autoFocus = false,
  error,
  required = false,
  readonly = false,
  ref: inputRef,
  withNotSet,
  autoComplete = '',
  rows = 1,
  maxLength,
  updateOnly,
  length = 16,
  copyClip = false,
}) => {
  const handleBlur = (blurValue: string) => {
    setFieldError(name, validateRegexPattern(blurValue) ?? undefined);
  };

  return (
    <TextInput
      name={name}
      label={label || 'Regex Pattern'}
      disabled={disabled}
      autoFocus={autoFocus}
      error={error}
      fullWidth={fullWidth}
      required={required}
      ref={inputRef}
      readonly={readonly}
      withNotSet={withNotSet}
      onChange={onChange}
      onBlur={handleBlur}
      onEnter={onEnter}
      value={value}
      type={rows ? 'textarea' : 'text'}
      autoComplete={autoComplete}
      rows={rows}
      maxLength={maxLength}
      updateOnly={updateOnly}
      length={length}
      copyClip={copyClip}
    />
  );
};

export default RegexPatternInput;
